import type { GiraResponse, GiraUser, User } from './types';

export const transformGiraResponse = (response: GiraResponse): User[] =>
	response.data.users.nodes.map((user: GiraUser) => ({
		id: user.accountId,
		name: user.displayName,
		key: user.key,
		avatarUrl: user.avatarUrl,
		type: 'user',
		fixed: false,
		accountType: user.accountType,
	}));
